import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { fromEvent, merge, of, Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Globals } from '../globals/globals';

const IDLE_TIMEOUT_MS = 30 * 60 * 1000; // 30 minutes

@Injectable({ providedIn: 'root' })
export class IdleTimeoutService implements OnDestroy {
  private subscription: Subscription | null = null;

  constructor(
    private globals: Globals,
    private router: Router,
    private ngZone: NgZone
  ) {}

  start(): void {
    this.stop();
    const activity$ = merge(
      of(null), // start the timer immediately on login
      fromEvent(document, 'mousemove'),
      fromEvent(document, 'mousedown'),
      fromEvent(document, 'keydown'),
      fromEvent(document, 'touchstart'),
      fromEvent(document, 'scroll')
    );

    // run outside Angular zone to avoid triggering change detection on every user event
    this.ngZone.runOutsideAngular(() => {
      this.subscription = activity$.pipe(
        switchMap(() => timer(IDLE_TIMEOUT_MS))
      ).subscribe(() => {
        this.ngZone.run(() => this.sessionExpired());
      });
    });
  }

  stop(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  }

  private sessionExpired(): void {
    this.stop();
    this.globals.isAuthenticated = false;
    this.globals.isAdmin = false;
    this.globals.user = null;
    this.globals.token = null;
    this.router.navigate(['/login']);
  }

  ngOnDestroy(): void {
    this.stop();
  }
}
